import { requestServiceDeskFromPortalExperienceId } from '@atlassian/help-center-common-util/analytics/ufo/ufo';
import { ExperiencePerformanceTypes, ExperienceTypes, UFOExperience } from '@atlassian/ufo';

export const requestServiceDeskFromPortalExperience = new UFOExperience(requestServiceDeskFromPortalExperienceId, {
    type: ExperienceTypes.Load,
    performanceType: ExperiencePerformanceTypes.PageSegmentLoad,
});
